module.exports = __webpack_public_path__ + "img/chinesecompany170.9d3f9670.png";